import { alpha, Box, Button, TextField, Typography, useTheme } from '@mui/material';

interface TradeSharesInputProps {
  value: string;
  onChange: (value: string) => void;
  onQuickAdd: (amount: number) => void;
}

export function TradeSharesInput({ value, onChange, onQuickAdd }: TradeSharesInputProps) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography sx={{ fontSize: '1.125rem', color: 'text.secondary', fontWeight: 600 }}>
          Shares
        </Typography>
        <TextField
          value={value}
          onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, ''))}
          placeholder="0"
          sx={{
            width: 160,
            '& .MuiInputBase-root': {
              height: 52,
              borderRadius: '16px',
              fontWeight: 800,
              fontSize: '1.25rem',
              bgcolor: alpha(theme.palette.action.hover, 0.05),
              border: '1px solid',
              borderColor: alpha(theme.palette.divider, 0.1),
              '& fieldset': { border: 'none' },
              '& input': { textAlign: 'right', px: 2 },
            },
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        {[10, 100, 500].map((amt) => (
          <Button
            key={amt}
            onClick={() => onQuickAdd(amt)}
            sx={{
              borderRadius: '12px',
              fontSize: '0.875rem',
              fontWeight: 700,
              color: 'text.primary',
              bgcolor: alpha(theme.palette.action.hover, 0.05),
              border: '1px solid',
              borderColor: alpha(theme.palette.divider, 0.1),
              minWidth: 'auto',
              px: 2,
              py: 0.75,
              textTransform: 'none',
              '&:hover': {
                bgcolor: alpha(theme.palette.action.hover, 0.1),
                borderColor: alpha(theme.palette.divider, 0.2),
              },
            }}
          >
            +{amt}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
